import { render, staticRenderFns } from "./MusicStreamingMethod.vue?vue&type=template&id=324af562&scoped=true&"
import script from "./MusicStreamingMethod.vue?vue&type=script&lang=ts&"
export * from "./MusicStreamingMethod.vue?vue&type=script&lang=ts&"
import style0 from "./MusicStreamingMethod.vue?vue&type=style&index=0&id=324af562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324af562",
  null
  
)

export default component.exports